import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Share2 } from "lucide-react";

const blogs = [
  {
    id: 1,
    title: "Small Steps Today. Big Dreams Tomorrow.",
    excerpt:
      "We interacted with children and parents during our awareness initiative, sharing the importance of early financial awareness and planning for a secure future.",
    author: "Team Wealthies",
    date: "April 2026",
    blogPath: "small-steps-big-dreams",
    image: "/assets/awarenessImg4.jpeg",
  },
  {
    id: 2,
    title: "Top 5 Investment Strategies for Beginners",
    excerpt:
      "Starting your investment journey? These proven strategies will help you build wealth confidently.",
    author: "Vijay M D",
    date: "March 18, 2026",
    blogPath: "investment-strategies-for-beginners",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f",
  },
  {
    id: 3,
    title: "Why Term Insurance is a Must-Have",
    excerpt:
      "A simple breakdown of why term insurance should be part of your financial planning.",
    author: "Vijay M D",
    date: "March 15, 2026",
    blogPath: "why-term-insurance-is-a-must-have",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f",
  },

  // ✅ NEW BLOG ADDED
  {
    id: 4,
    title: "Understanding Life Insurance in 2026",
    excerpt:
      "Life insurance is evolving rapidly. Here's everything you need to know to make smarter financial decisions.",
    author: "Vijay M D",
    date: "March 20, 2026",
    blogPath: "life-insurance-in-2026",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85",
  },
];

const Container = styled.div`
  min-height: 100vh;
  background: #f9fafb;
  padding: 120px 16px;
`;

const Wrapper = styled.div`
  max-width: 1100px;
  margin: 20px auto;
`;

const Title = styled.h1`
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 40px;
`;

const Card = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
  transition: 0.3s;

  &:hover {
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  }

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 250px;
  /* object-fit: cover; */

  @media (min-width: 768px) {
    height: 100%;
  }
`;

const Content = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Meta = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 8px;
`;

const BlogTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
  cursor: pointer;

  &:hover {
    color: #374151;
  }
`;

const Excerpt = styled.p`
  color: #4b5563;
  margin-bottom: 16px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Button = styled.button`
  padding: 10px 16px;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background: #333;
  }
`;

const IconGroup = styled.div`
  display: flex;
  gap: 16px;
  color: #6b7280;

  svg {
    cursor: pointer;
  }
`;

const BlogCard = ({ blog }) => {
  const handleShare = async () => {
    const shareData = {
      title: blog.title,
      text: blog.excerpt,
      url: `${window.location.origin}/blog/${blog.blogPath}`,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData); // Mobile share
      } else {
        await navigator.clipboard.writeText(shareData.url); // Desktop fallback
        alert("Link copied to clipboard!");
      }
    } catch (err) {
      console.error("Share failed:", err);
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Card>
        <Image src={blog.image} alt={blog.title} />

        <Content>
          <div>
            <Meta>
              {blog.date} • {blog.author}
            </Meta>

            <BlogTitle>{blog.title}</BlogTitle>
            <Excerpt>{blog.excerpt}</Excerpt>
          </div>

          <Footer>
            <Button
              onClick={() => (window.location.href = `/blog/${blog.blogPath}`)}
            >
              Read More
            </Button>

            <IconGroup>
              <Share2 onClick={handleShare} />
            </IconGroup>
          </Footer>
        </Content>
      </Card>
    </motion.div>
  );
};

export default function BlogHome() {
  return (
    <Container>
      <Wrapper>
        <Title>Latest Blogs</Title>

        {blogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </Wrapper>
    </Container>
  );
}
